import React, { useEffect, useState } from 'react'
import ArrowLeftIcon from '../Icons/ArrowLeft'
import Modal from '.'
import CloseIcon from '../Icons/CloseIcon'
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete'

const AddressSearchModal = ({ show = false, onClose, onAddressSelect }) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
    cache: 24 * 60 * 60,
  })

  const handleSelect = async (suggestion) => {
    setValue(suggestion.description, false)
    clearSuggestions()

    try {
      const results = await getGeocode({ address: suggestion.description })
      const { lat, lng } = await getLatLng(results[0])
      onAddressSelect({
        formatted_address: suggestion.description,
        geometry: {
          location: { lat, lng },
        },
      })
    } catch (error) {
      console.error('Error selecting address:', error)
    }
  }

  return (
    <Modal
      isOpen={show}
      onClose={onClose}
      fullScreen={true}
      showCloseBtn={false}
    >
      <div className="flex items-center justify-between gap-4 p-4">
        <button onClick={onClose}>
          <ArrowLeftIcon />
        </button>
        <div className="relative flex-1 border border-gray-400 rounded-lg overflow-hidden">
          <input
            className="w-full px-4 py-2 placeholder:text-gray-400 placeholder:text-xs text-sm"
            type="text"
            placeholder="Search for area, street name..."
            onChange={(e) => setValue(e.target.value)}
            value={value}
            disabled={!ready}
            autoFocus
          />
          {value.length > 1 && (
            <button
              className="absolute right-2 top-1/2 -translate-y-1/2 p-2"
              onClick={() => {
                setValue('')
                clearSuggestions()
              }}
            >
              <CloseIcon width={20} height={20} />
            </button>
          )}
        </div>
      </div>

      <div>
        {status === 'OK' && (
          <ul className="px-4 h-[calc(100vh-100px)] overflow-y-auto">
            {data.map((suggestion) => {
              const {
                place_id,
                structured_formatting: { main_text, secondary_text },
              } = suggestion

              return (
                <li key={place_id} className="py-2">
                  <button
                    onClick={() => handleSelect(suggestion)}
                    className="w-full text-left"
                  >
                    <p className="text-gray-800 text-sm">{main_text}</p>
                    <p className="text-gray-600 text-[10px]">
                      {secondary_text}
                    </p>
                  </button>
                </li>
              )
            })}
          </ul>
        )}
      </div>
    </Modal>
  )
}

export default AddressSearchModal
